import Vue from "vue";
import Vuex from "vuex";
import { formatVat } from "@/validators/vat";

Vue.use(Vuex);

const flows = ["guest", "customer"];

export default new Vuex.Store({
	state: {
		flow: "",
		company_name: "",
		person_name: "",
		email: "",
		vat: "",
		visitor_id: "",
		did_win: false
	},
	mutations: {
		begin(state) {
			state.visitor_id = "";
			state.flow = "";
			state.company_name = "";
			state.person_name = "";
			state.email = "";
			state.vat = "";
			state.did_win = false;
		},
		setDidWin(state) {
			state.did_win = true;
		},
		setFlowGuest(state) {
			state.flow = flows[0];
		},
		setFlowCustomer(state) {
			state.flow = flows[1];
		},
		setCompanyName(state, value) {
			state.company_name = value;
		},
		setPersonName(state, value) {
			state.person_name = value;
		},
		setEmail(state, value) {
			state.email = value;
		},
		setVat(state, value) {
			state.vat = value;
		},
		formatVat(state) {
			state.vat = formatVat(state.vat);
		},
		setVisitorId(state, value) {
			state.visitor_id = value;
		}
	},
	actions: {
		async logVisitAndRoll({ dispatch }) {
			await dispatch("logVisit");
			await dispatch("rollDice");
		},
		rollDice({ state, commit }) {
			return Vue.axios
				.post(`/api/winners/${state.visitor_id}`)
				.then(response => {
					if (response.data.won === true) {
						commit("setDidWin");
					}
				});
		},
		logVisit({ state, commit }) {
			return Vue.axios
				.post("/api/visitors", {
					visitor: {
						company_name: state.company_name,
						person_name: state.person_name,
						email: state.email,
						vat: state.vat
					}
				})
				.then(response => {
					commit("setVisitorId", response.data.visitor.id);
				});
		}
	}
});
